import React from "react"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { tableStatusColors } from "constant"
import classes from "./KitchenTablesLegend.module.scss"

const KitchenTablesLegend = () => {
  const [t, i18n] = useTranslation()

  const statusLabels = {
    busy: t("اشغال"),
    ready: t("آماده")
  }

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div
      className={clsx(
        classes["legendContainer"],
        isLtr && classes["legendContainer-ltr"]
      )}
    >
      <div
        className={clsx(
          classes["title"],
          isLtr && classes["title-ltr"]
        )}
      >
        {t("توضیحات")}:
      </div>
      {Object.keys(tableStatusColors).map(status =>
        <div
          key={status}
          className={clsx(
            classes["legend"],
            isLtr && classes["legend-ltr"]
          )}
        >
          <div
            className={classes["box"]}
            style={{ backgroundColor: `var(--color-${tableStatusColors[status]})` }}
          />
          <div
            className={clsx(
              classes["text"],
              isLtr && classes["text-ltr"]
            )}
          >
            {statusLabels[status]}
          </div>
        </div>
      )}
    </div>
  )
}

export default KitchenTablesLegend